import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Tag,
  Modal,
  notification,
  Divider,
  DatePicker
} from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import AnimateHeight from "react-animate-height";
import AcordoInfos from "./AcordoInfos";

import "./styles.css";
import AcordoParcelas from "./AcordoParcelas";
import api from "../../../../services/api";
import handleError from "../../../../services/apiErrorHandler";
import * as Permissions from "../../../../services/permissions";
import { AcordoContratos } from "./AcordoContratos";
import { isSuperUser } from "../../../../utils/is-superuser";

export default class AcordoView extends Component {
  static propTypes = {
    acordo: PropTypes.object,
    pasta: PropTypes.object
  };

  state = {
    expanded: 0,
    acordo: this.props.acordo,
    status_selected: null,
    status_changing: false
  };

  /** Expande o acordo */
  handleOpen = () => {
    this.setState({
      expanded: this.state.expanded == 0 ? "auto" : 0
    });
  };

  handleUpdateAcordo = async () => {
    /** Atualiza as informações do acordo */
    await api
      .get(`/acordo/acordos/${this.props.acordo.id}/`)
      .then(response => {
        const acordo = response.data;

        this.setState({
          acordo: acordo
        });
      })
      .catch(err => {
        //console.log(err);
      });
  };

  handleSelectStatusChange = event => {
    const selected = event.target.value;
    let isQuebra = selected.includes("Quebrado");
    this.setState({
      status_selected: selected,
      isQuebra: isQuebra
    });
  };

  /**
   * Atualiza o status do acordo
   */
  handleStatusChange = async () => {
    const status = this.state.status_selected;

    if (status == null || status == "0") {
      Modal.error({
        title: "Error",
        content: "Selecione um status."
      });
      return;
    } else if (this.state.isQuebra && this.state.data_quebra === null) {
      Modal.error({
        title: "Error",
        content: "Quando o status é uma quebra você PRECISA setar a data."
      });
      return;
    } else if (!this.state.isQuebra && this.state.data_quebra !== null) {
      Modal.error({
        title: "Error",
        content: "Se o status não é uma quebra NÃO preencha a data"
      });
      return;
    }
    this.setState({
      status_changing: true
    });

    await api
      .put(`/acordo/update-status/${this.state.acordo.id}/`, {
        status_acordo: this.state.status_selected,
        data_quebra: this.state.data_quebra
      })
      .then(async response => {
        let res = await api.get(`/acordo/acordos/${this.state.acordo.id}/`);

        const updated_data = res.data;
        const parcelas = this.state.acordo.parcelas; // Parcelas do acordo

        updated_data.parcelas = parcelas;

        this.setState({
          acordo: updated_data
        });

        notification.success({
          message: "Status do acordo atualizado com sucesso."
        });
      })
      .catch(err => {
        Modal.error({
          title: "Error",
          content: handleError(err)
        });
      });

    this.setState({
      status_changing: false
    });
  };

  /** Exclui o acordo */
  handleDelete = async () => {
    await api
      .delete(`acordo/acordos/${this.state.acordo.id}/`)
      .then(() => {
        notification.success({
          message: "Acordo excluido com sucesso!"
        });

        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch(() => {
        Modal.error({
          title: "Erro",
          content: "Ocorreu um erro ao excluir o acordo"
        });
      });
  };

  /** Ação executada ao clicar no botão para excluir o acordo */
  handleDeleteClick = () => {
    const modal = Modal.confirm();

    modal.update({
      content: "Deseja excluir o acordo?",
      okText: "Confirmar",
      cancelText: "Cancelar",
      onOk: this.handleDelete,
      onCancel: modal.destroy
    });
  };

  onChangeDate = item => {
    if (item !== null) {
      this.setState({ ...this.state, data_quebra: item.format("YYYY-MM-DD") });
    } else {
      this.setState({ ...this.state, data_quebra: item });
    }
  };

  /** Ação executada ao clicar para alterar o status do acordo */
  handleStatusClick = () => {
    const modal = Modal.confirm();

    this.setState({
      status_selected: null,
      data_quebra: null,
      isChange: false
    });

    const content = (
      <div style={{ margin: "15px" }}>
        <label>Selecione o status do acordo:</label>
        <select
          className="ant-input"
          style={{ marginTop: "5px" }}
          onChange={this.handleSelectStatusChange}
          defaultValue="0"
        >
          <option value="0">Selecione</option>
          <option value="ATIVO">Ativo</option>
          <option value="Cancelado">Cancelado</option>
          <option value="Quebrado - Não pagamento">
            Quebrado - Não pagamento
          </option>
          <option value="Reacordo">Reacordo</option>
          <option value="Quitado">Quitado</option>
        </select>
        <DatePicker onChange={this.onChangeDate} placeholder="Data da quebra" />
      </div>
    );

    modal.update({
      title: "Alterar status do acordo",
      okText: "Confirmar",
      cancelText: "Cancelar",
      content: content,
      onCancel: modal.destroy,
      onOk: this.handleStatusChange,
      icon: null
    });
  };

  /** Caso o acordo esteja ganho, retorna a Tag GANHO */
  acordo_ganho() {
    if (this.state.acordo.ganho) {
      return (
        <React.Fragment>
          <Tag color="green">GANHO</Tag>
          <Divider type="vertical"></Divider>
        </React.Fragment>
      );
    }
  }

  getContratos = () => {
    let contrato = "";
    this.state.acordo.contrato_set.forEach((value, index) => {
      if (index == 0) {
        contrato = value.contrato;
      } else {
        contrato = contrato + ", " + value.contrato;
      }
    });
    return contrato;
  };

  render() {
    // Cor do status
    let statusColor = "red";
    let status = String(this.state.acordo.status_acordo);
    const isAdmin = isSuperUser();

    if (status.includes("Quebrado")) {
      if (this.state.acordo.data_quebra !== null) {
        status =
          status +
          ` - ${moment(this.state.acordo.data_quebra).format("DD/MM/YYYY")}`;
      } else {
        status = status + " - Sem data da quebra";
      }
    }

    if (
      status.toLowerCase().indexOf("ativo") != -1 ||
      status.toLowerCase().indexOf("quitado") != -1
    )
      statusColor = "green";

    return (
      <div className="acordo__container">
        <div style={{ width: "100%" }}>
          <Row
            gutter={8}
            style={{
              display: "flex",
              alignItems: "center"
            }}
          >
            <Col sm={{ span: 18 }}>
              <div className="acordo__container_item">
                {this.acordo_ganho()}
                <span className="acordo__badge">
                  <Tag color={`${statusColor}`}>{status}</Tag>
                </span>
                <Divider type="vertical" />
                <span className="acordo__type">
                  {this.state.acordo.tipo_acordo}
                </span>
                <Divider type="vertical" />
                <span className="acordo__type">
                  {this.state.acordo.tipo_cobranca}
                </span>
                <Divider type="vertical" />
                <span className="acordo__type">{this.getContratos()}</span>
                <Divider type="vertical" />
                <span className="acordo__type">
                  Nº Cliente: {this.state.acordo.numero_cliente || "---"}
                </span>
              </div>
            </Col>
            <Col sm={{ span: 6 }}>
              <div
                className="acordo__container_item"
                style={{ textAlign: "end" }}
              >
                <Button type="primary" onClick={this.handleOpen}>
                  {this.state.expanded == 0 ? "Expandir" : "Ocultar"}
                </Button>
              </div>
            </Col>
          </Row>
          <AnimateHeight duration={350} height={this.state.expanded}>
            <div className="acordo__infos">
              <hr />
              <AcordoInfos
                acordo={this.state.acordo}
                pasta={this.props.pasta}
              />
              <AcordoContratos contratos={this.state.acordo.contrato_set} />
              <AcordoParcelas
                parcelas={this.state.acordo.parcela_set}
                acordo={this.state.acordo}
                handleUpdate={this.handleUpdateAcordo}
              />
            </div>
            <div className="acordo__actions">
              {isAdmin ? (
                <Button
                  type="primary"
                  onClick={this.handleStatusClick}
                  loading={this.state.status_changing}
                >
                  Alterar status
                </Button>
              ) : null}
              &nbsp;&nbsp;
              {isAdmin ? (
                <Button
                  type="danger"
                  onClick={this.handleDeleteClick}
                  loading={this.state.status_changing}
                >
                  Excluir acordo
                </Button>
              ) : null}
            </div>
          </AnimateHeight>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Acordo/View/AcordoView/index.js